// provides utility constants

// miscellaneous
export const borderRadius = '4px';

// breakpoints
export const viewportWidthExtraSmall = '480px';
export const viewportWidthSmall = '768px';
export const viewportWidthMedium = '960px';

// layout sizes
export const drawerWidth = 240;
export const shrinkedDrawerWidth = 72;